export default {
  title: 'Google Business',
  sections: {
    google_business_info: 'Informações do Google Business',
    google_reviews: 'Avaliações do Google',
    settings: 'Definições',
    danger_zone: 'Zona de perigo',
  },
  form: {
    reviews_autopilot_enabled: {
      label: 'Respostas automáticas por IA',
    },
    reviews_autopilot_daily_limit: {
      label: 'Limite diário de respostas automáticas por IA (mín. 1, máx. 15)',
    },
    reviews_autopilot_delay_hours: {
      label: 'Número de horas a aguardar após escrever uma avaliação',
    },
    unanswered_checkbox: {
      show_all_reviews: 'Mostrar todas as avaliações',
      show_only_unanswered: 'Mostrar apenas sem resposta',
    },
    rating_filter: {
      label: 'Filtro por classificação',
      stars_one: '{{count}} estrela',
      stars_other: '{{count}} estrelas',
    },
    sorting: {
      newest_to_oldest: 'Ordenar do mais recente para o mais antigo',
      oldest_to_newest: 'Ordenar do mais antigo para o mais recente',
      rating_highest_to_lowest: 'Ordenar por classificação mais alta primeiro',
      rating_lowest_to_highest: 'Ordenar por classificação mais baixa primeiro',
    },
  },
  table: {
    pagination: {
      total_one: 'Total de {{count}} avaliação',
      total_other: 'Total de {{count}} avaliações',
    },
  },
  modal_publish: {
    title: 'Tem a certeza de que pretende publicar no Google?',
    buttons: {
      yes: 'Sim',
      cancel: 'Cancelar',
    },
  },
  popconfirm: {
    title: 'Tem a certeza?',
    description: 'Todas as alterações locais serão substituídas',
  },
  disconnect_profile: {
    title: 'Desligar perfil',
    button: 'Continuar',
    popconfirm: {
      title: 'Tem a certeza?',
      description:
        'Isto irá desligar completamente este perfil do Google do sistema Foodamigos, incluindo a substituição automática de links e o piloto automático de respostas a avaliações!',
    },
  },
  buttons: {
    login_with_google: 'Iniciar sessão com o Google',
    sync_from_google: 'Obter Versão Atualizada',
    publish_to_google: 'Publicar no Google',
    previous: 'Anterior',
    next: 'Seguinte',
    save_settings: 'Guardar Definições',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar as alterações',
    failed_to_fetch_reviews: 'Falha ao obter as avaliações',
    failed_to_fetch_settings: 'Falha ao obter as definições',
    failed_to_load_google_business: 'Falha ao carregar o Google Business',
    failed_to_publish_to_google_business: 'Falha ao publicar no Google Business',
    publish_access_denied:
      'A Google recusou a atualização: a conta Google ligada já não pode editar este Perfil da Empresa. Verifique o acesso no Google Business Profile ou volte a ligar com a conta que gere o restaurante.',
    failed_to_fetch_info: 'Falha ao obter a versão atualizada do Google Business',
    success_publish_to_google_business: 'Publicado com sucesso no Google Business',
    success_sync_from_google: 'Sincronizado com sucesso a partir do Google Business',
    success_save_settings: 'Definições guardadas com sucesso',
    failed_to_disconnect_profile: 'Falha ao desligar o Google Business. Por favor, contacte a equipa técnica!',
    popup_blocked: 'Permita pop-ups para este site para ligar o Google Business.',
    failed_to_connect: 'Não foi possível ligar o Google Business. Tente novamente.',
    no_business_profile:
      'Esta conta Google não gere nenhum Perfil da Empresa. Inicie sessão com a conta Google que gere o restaurante.',
  },
  callback: {
    connecting: 'A ligar o Google Business…',
    connected: 'O Google Business está ligado. Pode fechar esta janela.',
    cancelled: 'O início de sessão foi cancelado. Pode fechar esta janela.',
    failed: 'Não foi possível ligar o Google Business. Feche esta janela e tente novamente.',
  },
  alerts: {
    no_profile: {
      title: 'Nenhum Google Place associado',
      description: 'Por favor, associe o restaurante a um Google Place.',
      button: {
        connect: 'Associar',
      },
    },
    unverified_location: {
      title: 'O Google Business não está verificado',
      description: 'Verifique o seu Google Business para continuar',
    },
  },
};
